const BASE_URL = "https://ansul.domotec.com.uy"; // ojo en producción !

export const loginURL = () => `${BASE_URL}/api/login.php`;
export const ackAlarmURL = () => `${BASE_URL}/api/systemEvent/update`;
export const addMaintenanceURL = () => `${BASE_URL}/api/systemMaintenance/create`;
export const allEventsURL = (token, systemId) => `${BASE_URL}/api/systemEvent/read.php?token=${token}&system_id=${systemId}`;
export const allMaintenanceURL = (token, systemId) => `${BASE_URL}/api/systemMaintenance/read.php??token=${token}&id=${systemId}`;
export const allSystems = token => `${BASE_URL}/api/system/read.php?token=${token}`;
export const imageURL = id => `${BASE_URL}/api/getFile.php?t=sf&file=${id}`;
export const lastMaintenanceURL = (token, systemId) => `${BASE_URL}/api/systemMaintenance/read.php?token=${token}&last&id=${systemId}`;
export const systemURL = (token, systemId) => `${BASE_URL}/api/system/read.php?token=${token}&id=${systemId}`;

export const fechaISO = date => (date ? new Date(date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10));

export const traducirEvento = eventValue => {
    switch (eventValue) {
        case "Input 1 Open;":
            return "ALERT - System Armed";
        case "Input 1 Closed;":
            return "ALERT - System Fired";
        case "Input 2 Open;":
            return "WARNING - Cabinet Closed";
        case "Input 2 Closed;":
            return "WARNING - Cabinet Open";
        default:
            return "UNKNOWN";
    }
};
